import { render, staticRenderFns } from "./MoralPointCardManage.vue?vue&type=template&id=3e2f1845&scoped=true"
import script from "./MoralPointCardManage.vue?vue&type=script&lang=js"
export * from "./MoralPointCardManage.vue?vue&type=script&lang=js"
import style0 from "./MoralPointCardManage.vue?vue&type=style&index=0&id=3e2f1845&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2f1845",
  null
  
)

export default component.exports